import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

const SessionsManagement = lazyWithRetry(
  () => import("./ui/pages/SessionsManagement"),
  "SessionsManagement",
);

const sessionsRoutes = buildRoutes([
  {
    path: "/sessions-management",
    element: SessionsManagement,
    roles: [1, 5],
  },
]);

export default sessionsRoutes;
